import Button from '../../../../../components/Button/Button';
import Modal from '../../../../../components/Modal/Modal';
import Table from '../../../../../components/Tables/Table/Table';
import { FC, useEffect, useState } from 'react';
import Link from '../../../../../components/Link/Link';
import LinkIcon from '@mui/icons-material/Link';
import { Typography, Box } from '@mui/material';
import { CellContext } from '@tanstack/react-table';

import styles from './LinkedBundleModal.module.css';
import { LinkedBundleModalProps } from './LinkedBundleModal.types';
import { LinkedBundles } from '@/types/bundles.types';

const ViewBundle: FC<CellContext<LinkedBundles, unknown>> = ({ row }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Link to={`/bundles/${row.original.id}`}>{row.original.code}</Link>
    {row?.original?.code && <LinkIcon style={{ fontSize: '20px', color: '#266DCC' }} />}
  </div>
);

const LinkedBundleModal: FC<LinkedBundleModalProps> = ({ isOpen, onClose, selectedRows, linkedBundleName }) => {
  const [openModal, setOpenModal] = useState(isOpen);

  useEffect(() => {
    setOpenModal(isOpen);
  }, [isOpen]);

  return (
    <Modal
      className={styles.editBundleModal}
      data-testid="linkedBundleModal"
      isOpen={openModal}
      onClose={() => {
        setOpenModal(false);
        onClose();
      }}
      headerContent={
        <Box textAlign="center" p={2}>
          <Typography variant="h6" component="div" fontWeight="bold" fontSize="3.2rem">
            <Box display="flex" alignItems="center" justifyContent="center" marginBottom="-25px">
              <Box display="inline">
                <LinkIcon style={{ fontSize: '29px', color: '#266DCC', marginTop: '10px' }} />
              </Box>
              <Box display="inline" mr={1}>
                &nbsp;{linkedBundleName}
              </Box>
            </Box>
          </Typography>
        </Box>
      }
      showTitleDivider
      maxWidth="610px"
      bodyContent={
        <div className={styles.body}>
          <div className={styles.currentSettings}>
            <Table
              includeMinWidth={false}
              height={selectedRows.length > 3 ? '173px' : undefined}
              data={selectedRows}
              columns={[
                { accessorKey: 'code', cell: ViewBundle, enableSorting: true, header: 'Bundle Code' },
                { accessorKey: 'name', enableSorting: true, header: 'Display Name' },
                { accessorKey: 'internalName', enableSorting: true, header: 'Bundle Desc.' },
              ]}
            />
          </div>
          <div className={styles.bodyDivider} />
        </div>
      }
      footerContent={
        <div className={styles.footer}>
          <div className={styles.footerContainer} />
          <div className={styles.buttonContainer}>
            <Button onClick={onClose}>Close</Button>
          </div>
        </div>
      }
    />
  );
};

export default LinkedBundleModal;
